export const addAuthenticateUser = (user) => {
  return (dispatch) => {
    dispatch({
      type: "authenticateUser",
      payload: user,
    });
  };
};
export const addSwitchedSociety = (societyId) => {
  return (dispatch) => {
    dispatch({
      type: "switchedSociety",
      payload: societyId,
    });
  };
};

export const addGroupWiseLevelData = (groupWiseLevelData) => {
  return (dispatch) => {
    dispatch({
      type: "groupWiseLevelData",
      payload: groupWiseLevelData,
    });
  };
};

export const userHasSocieties = (userAccessibleSocieties) => {
  return (dispatch) => {
    // Extract unique societies from userAccessibleSocieties
    const uniqueSocieties = Array?.from(
      new Map(
        userAccessibleSocieties?.map((item) => [item.society._id, item.society])
      ).values()
    );

    dispatch({
      type: "userHasSocieties",
      payload: uniqueSocieties,
    });
  };
};

export const userHasRoleWithPermission = (userAccessibleSocieties) => {
  return (dispatch) => {
    // Create a map of society-wise roles and permissions
    const societyWiseRolesAndPermissions = userAccessibleSocieties?.reduce(
      (acc, item) => {
        const societyId = item.society._id;

        if (!acc[societyId]) {
          acc[societyId] = {
            roles: [],
          };
        }
        // Add role and its permissions
        acc[societyId].roles.push({
          roleDisplayName: item.roleDisplayName,
          levelDataAccess: item.levelDataAccess,
          viewLevelsModel: item.viewLevelsModel,
          uniqueId: item.uniqueId,
          accessTypeId: item.accessTypeId,
          permissions: item.permissions,
          hierarchyIds: item.hierarchyIds || [],
          accessType: item.accessType,
          userAccessId:item?._id
        });

        return acc;
      },
      {}
    );

    dispatch({
      type: "userHasRoleWithPermission",
      payload: societyWiseRolesAndPermissions,
    });
  };
};

export const switchedRole = (role) => {
  return (dispatch) => {
    dispatch({
      type: "switchedRole",
      payload: role,
    });
  };
};

export const updateAuthenticateUser = (updatedFields) => {
  return (dispatch, getState) => {
    const currentUser = getState().user;

    const updatedUser = {
      ...currentUser,
      ...updatedFields,
    };

    dispatch({
      type: "authenticateUser",
      payload: updatedUser,
    });
  };
};
